export const appInfo = {
  version: 'v_1.4',
  environment: 'Production',
  database: 'Production',
  lastUpdated: '16:50 IST, 21 Jan 2026'
};

export default appInfo;
